import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css';
// import "font-awesome/css/font-awesome.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/lib/integration/react";
import App from "./App";
import 'react-phone-input-2/lib/material.css'
import "./index.css";
import "core-js/stable";
import "regenerator-runtime/runtime";
import { LoaderProvider } from "./contextApi/toggleLoader";
import store, { persistor } from "./store";
import { HashRouter, useLocation } from "react-router-dom";
const root = createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <LoaderProvider>
          <HashRouter>
            <App />
          </HashRouter>
        </LoaderProvider>

      </LocalizationProvider>
    </PersistGate>
  </Provider>
);
